import React, { useEffect, useState } from "react";
import Courses from "./courses";
import { Helmet } from "react-helmet-async";
import { getCategory } from "../Services/Api";

const CourseSelector = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loadingCategories, setLoadingCategories] = useState(true);

  const courseSectionRef = React.useRef(null); // ✅ added ref

 useEffect(() => {
  const cachedCategories = localStorage.getItem("categories");

  if (cachedCategories) {
    // Load instantly from cache (no skeleton)
    setCategories(JSON.parse(cachedCategories));
    setLoadingCategories(false);
    return;
  }

  // First-time visit → fetch and store
  const fetchCategories = async () => {
    try {
      setLoadingCategories(true);
      const res = await getCategory("category");
      const categoryData = res?.categories || res;

      setCategories(categoryData);

      // Save to localStorage
      localStorage.setItem("categories", JSON.stringify(categoryData));
    } catch (error) {
      console.error("Failed to fetch categories:", error);
    } finally {
      setLoadingCategories(false);
    }
  };

  fetchCategories();
}, []);


  const skeletonArray = Array(10).fill(0);

  return (
    <>
    <Helmet>
        <title>Courses – Explore All Programs | EDC Learning</title>
      <meta name="description" content="Browse all available courses from EDC Learning. Improve your skills with certified programs in tech, business, and professional development." />
      <meta name="keywords" content="courses, learning, edc, education, skills" />
      <meta property="og:title" content="Courses - EDC Learning" />
      <meta property="og:description" content="Find the right course to upskill yourself." />
      <meta property="og:image" content="/images/LSClogo.png" />
      <meta property="og:url" content="https://edc.lsc-india.org/" />
      <meta name="twitter:card" content="summary_large_image" />
   </Helmet>
      <section
        className="bg-gray-50 px-6 py-5"
        style={{ backgroundColor: "rgb(219 228 220 / 23%)" }}
      >
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-20">
          
          {/* LEFT IMAGE */}
          <div className="md:w-4/12 flex justify-center md:justify-start">
            <img
              src="/images/Edc webpage design-01.webp"
              alt="Learning illustration"
              className="w-85 h-[450px] object-contain"
            />
          </div>

          {/* RIGHT CATEGORY BUTTONS */}
          <div className="md:w-8/12 text-center md:text-left space-y-6">
            <h1 className="text-2xl md:text-3xl font-semibold mb-2 py-4 text-dark leading-snug">
              Find the right course for you
            </h1>

            <div className="flex flex-wrap gap-3">
              {loadingCategories
                ? skeletonArray.map((_, idx) => (
                    <span
                      key={idx}
                      className="inline-block px-5 py-2 rounded-full bg-gray-300 animate-pulse text-transparent"
                      style={{ minWidth: "190px", height: "40px" }}
                    >
                      Loading
                    </span>
                  ))
                : categories.map((cat) => (
                    <span
                      key={cat.id}
                      onClick={() => {
                        setSelectedCategory(cat.id);

                        // 🔥 auto scroll to courses
                        setTimeout(() => {
                          courseSectionRef.current?.scrollIntoView({
                            behavior: "smooth",
                          });
                        }, 200);
                      }}
                      className={`inline-block px-5 py-2 rounded-full cursor-pointer border transition text-sm font-medium whitespace-nowrap
                        ${
                          selectedCategory === cat.id
                            ? "bg-white text-[#022c43] border-[#022c43]"
                            : "bg-[#5D4CCF] text-white border-transparent"
                        }`}
                    >
                      {(cat.category_name ?? "")
                        .toLowerCase()
                        .replace(/\b\w/g, (char) => char.toUpperCase())}
                    </span>
                  ))}
            </div>
          </div>
        </div>
      </section>

      {/* COURSES */}
      <Courses categoryId={selectedCategory} scrollRef={courseSectionRef} />
      
    </>
  );
};

export default CourseSelector;
